import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import useGetUrlParams from "./useGetUrlParams.js";
import { getFareOffersWithDetails } from "../store/brandedFareOffers/selectors.js";
import { getFlight } from "../store/flightDetails/selectors.js";
import { goal } from "@flights/et-universal";
import { getSearchResultsFlightOffers } from "../store/searchResults/selectors.js";
import useMetrics from "./useMetrics.js";
import { GRAPHITE_CLIENT_METRICS_NAMESPACE } from "@flights/constants";
const useTrackFlightDetailsBrandedFaresGoals = () => {
    const { getUrlParam } = useGetUrlParams();
    const { id: token } = useParams();
    const flight = useSelector(getFlight);
    const fareOffersWithDetails = useSelector(getFareOffersWithDetails);
    const searchResultsFlightOffers = useSelector(getSearchResultsFlightOffers);
    const baseOfferToken = getUrlParam("baseOfferToken");
    const { trackMetrics } = useMetrics();
    const searchResultOffer = searchResultsFlightOffers.find((offer) => offer.token === (baseOfferToken || token));
    const srFetchedBrandedFares = fareOffersWithDetails[baseOfferToken || token];
    let brandedFares = srFetchedBrandedFares?.brandedFareOffers;
    if (!brandedFares && flight?.token === token) {
        brandedFares = flight?.brandedFareOffers;
    }
    useEffect(() => {
        if (!brandedFares)
            return;
        if (brandedFares.length !== 0) {
            goal("flights_branded_fare_flight_detail_page_view");
            const fareIndex = brandedFares.findIndex((offer) => offer.token === token);
            if (fareIndex > 0) {
                goal("flights_branded_fare_upsell_flight_detail_page_view");
            }
        }
        const fdBrandedFaresCount = flight?.brandedFareOffers?.length ?? 0;
        const srBrandedFaresCount = srFetchedBrandedFares?.brandedFareOffers?.length ?? 0;
        if (!flight?.brandedFareOffers)
            return;
        if (srFetchedBrandedFares && searchResultOffer?.requestableBrandedFares) {
            const carrier = flight?.segments?.[0]?.legs?.[0]?.flightInfo?.carrierInfo?.marketingCarrier || "unknown";
            if (srBrandedFaresCount <= 1 && fdBrandedFaresCount > 1) {
                trackMetrics(GRAPHITE_CLIENT_METRICS_NAMESPACE, "branded_fares", [["by_metric", "missing_on_sr_available_on_fd", "by_carrier", carrier]], "count");
            }
            if (srBrandedFaresCount > 1 && fdBrandedFaresCount <= 1) {
                trackMetrics(GRAPHITE_CLIENT_METRICS_NAMESPACE, "branded_fares", [["by_metric", "available_on_sr_missing_on_fd", "by_carrier", carrier]], "count");
            }
        }
    }, [brandedFares, token, flight, searchResultOffer, srFetchedBrandedFares, trackMetrics]);
};
export default useTrackFlightDetailsBrandedFaresGoals;
